module.exports = __webpack_public_path__ + "img/mGyeongbokPalace2.bb7263ca.png";